import { colors } from '../theme';
import { isBright } from './helpers';

export const getContrastTextColor = (color) => {
  if (isBright(color)) {
    return colors.charcoal;
  }

  return colors.white;
};
